import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function TermsAndCondition() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleClickOpen}
        className="title"
        style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
        aria-label={t('footer.termsAndConitons')}
      >
        {t('footer.termsAndConitons')}
      </button>
      <Dialog
        className="common-dialog-style termsAndCondition-dialog"
        open={open}
        slotProps={{ paper: { className: 'paperClass' } }}
      >
        <DialogTitle className="header">
          {t('footer.termsAndConitons')}
          <IconButton aria-label="close" onClick={handleClose} className="closeIcon">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>{t('footer.termsAndConitons')}</DialogContent>
        <DialogActions className="footer">
          <Button variant="contained" onClick={handleClose}>
            {t('button.ok')}
          </Button>
          <Button variant="contained" aria-label="close" onClick={handleClose}>
            {t('button.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
